import React, {useEffect, useState} from 'react';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddComma, formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import '../TypePrintSadanShop/TypePrintSadanShop.scss'

const SingleReportPrint = (props) => {

  const [componentColumn, setComponentColumn] = useState([])
  const [componentData, setComponentData] = useState([])
  const [fieldColumn, setFieldColumn] = useState([]);
  const [commaColumn, setCommaColumn] = useState([]);

  useEffect(() => {
    setComponentData(props.data.currentData)
    setComponentColumn(props.data.data.column)
  }, []);

  useEffect(() => {
    if (componentColumn.length > 0) {
      let temp = []
      componentColumn.forEach((v) => {
        if (v.visible) {
          temp.push(v.field);
        }
        setFieldColumn(temp)
      });

      if (props.data.data.priceFields !== undefined) {
        let temp = []
        props.data.data.priceFields.forEach((v) => {
          temp.push(v)
        })
        setCommaColumn([...temp])
      }
    }
  }, [componentColumn])


  debugger
  try {
    return (
      <div className="main-print-factor" style={{rowGap: '3px'}}>
        {componentData.length > 0 && <>
          <div className="title-single-report">
            <p>{props.data.title}</p>
          </div>

          <table className="solid-print-table">
            <thead>
            <tr style={{height: '20px'}}>
              {componentColumn.map((v, index) =>
                <th style={{width: "fit-content", border: '1px solid white', borderBottom: '1px solid'}}
                    key={"C" + index}></th>
              )}
            </tr>
            <tr>
              {componentColumn.map((v, index) =>
                <th style={{width: "fit-content"}} key={"C" + index}>{v.title}</th>
              )}
            </tr>
            </thead>

            <tbody>
            {componentData?.map((q, index) => {
                return <tr key={"R" + index}>
                  {fieldColumn.map((f) =>
                    <th>
                      {commaColumn.includes(f) ? (
                        formatToPersianAddComma(q[f])
                      ) : (
                        (numericFunction.e2p(q[f]))
                      )}
                    </th>
                  )}
                </tr>
              }
            )}
            </tbody>

            <tfoot>
            <tr style={{height: '20px'}}>
              {componentColumn.map((v, index) =>
                <th style={{width: "fit-content", border: '1px solid white'}} key={"C" + index}></th>
              )}
            </tr>
            </tfoot>
          </table>
        </>}
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default SingleReportPrint;